import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles, Typography, Grid, Button, Paper } from '@material-ui/core';

const HomeThings = ({ thing, setInputText, setSearchQuery, setCurrPage }) => {

  const useStyles = makeStyles(theme => ({
    thingImg: {
      maxWidth: '100%'
    },
    imgBtn: {
      padding: 0,
      overflow: 'hidden'
    },
    thingName: {
      fontWeight: 600,
      margin: theme.spacing(2, 0)
    }
  }))
  
  const searchThing = () => {
    setInputText(thing);
    setSearchQuery(thing);
    setCurrPage(1);
  }

  const classes = useStyles();

  return (
    <Grid item xs={10} sm={5} md={4}>
      <Paper>
        <Button className={classes.imgBtn} component={Link} to="/shop" onClick={searchThing}>
          <img className={classes.thingImg} src={`/img/${thing.toLowerCase()}.jpg`} alt={thing} />
        </Button>
      </Paper>
      <Typography variant="h5" className={classes.thingName} align="center">{thing}</Typography>
    </Grid>
  )
}

export default HomeThings;